<template>
    <section class="pb_xl_py_cover overflow-hidden pb_slant-light pb_gradient_v1"  style="background-image: url(../assets/images/1900x1200_img_5.jpg)">

      <div :style="`background-image: url(${require('../assets/images/img3.jpg')});`" class="bg"></div>

      <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-5">
                    <form action="#" class="bg-white rounded pb_form_v1">
                        <h2 class="mb-4 mt-0">Контакты</h2>
                      <p class="mb-2">г. Краснодар, ул. Коммунаров 24</p>
                      <p class="mb-2">тел. 8-(909)-767-24-25</p>
                      <p class="mb-4">@zaya_krd</p>

                      <div class="form-group">
                        <input type="submit" class="btn btn-ok btn-lg btn-block pb_btn-pill  btn-shadow-blue" value="Забронировать онлайн">
                      </div>
                    </form>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-5 justify-content-center">

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style scoped>

</style>
